import { useMutation } from '@tanstack/react-query';
import { axiosClient } from '../axiosClient';

interface HousingResponseType {
  id: string;
  name: string;
  reports: {
    year: number;
  }[];
  rt90x: number;
  rt90y: number;
  wgs84lat: number;
  wgs84lon: number;
}

const useHousingAssociation = () => {
  return useMutation({
    mutationFn: async (
      orgNr: string | null
    ): Promise<HousingResponseType | null> => {
      if (!orgNr) return null;

      const URL = `${import.meta.env.VITE_API_HOUSING_ASSOCIATION_URL}/${orgNr}`;

      const { data } = await axiosClient.get<HousingResponseType>(URL);

      return data;
    },
  });
};

export default useHousingAssociation;
